/**
 * @file index.ts
 * @description Exports all auth utility functions for cleaner imports
 */

export { validateForm } from "./validateForm";
export { loginWithEmail } from "./loginWithEmail";
export { loginWithGoogle } from "./loginWithGoogle";
export { handleAuthError } from "./errorHandler"; 